<template>
  <a-layout class="setEstimated">
    <a-row justify="space-between" type="flex" class="nhf-header">
      <h1 class="nhf-title">
        <img class="nhf-logo" :src="logo" alt="返回上一页面" />
        <span>{{ factoryName }}</span>
      </h1>
      <a-space>
        <a-button
          size="small"
          style="width: 64px; margin-bottom: 6px"
          type="primary"
          @click="goBack"
          >返回</a-button
        >
      </a-space>
    </a-row>

    <div class="listContent">
      <!-- 筛选条件部分 -->
      <a-form :form="form" labelAlign="left" class="headForm">
        <a-row>
          <a-col :span="6">
            <a-form-item label="配方名称">
              <a-input v-decorator="['formulaName']" placeholder="请输入配方名称" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="选择日期">
              <a-range-picker v-decorator="['estimateDate']"></a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="动物类型">
              <a-cascader
                v-decorator="['typeArr']"
                :options="typeList"
                :load-data="loadData"
                placeholder="请选择动物类型"
                change-on-select
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="报告id">
              <a-input v-decorator="['reporterNo']" placeholder="请输入报告id" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <a-button
                type="primary"
                @click="getList({ current: 1, pageSize: pagination.pageSize })"
                >查询</a-button
              >
              <a-button style="margin: 0px 20px 0px 8px" @click="resetFields"
                >重置</a-button
              >
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <!-- <div class="editBox" style="height: 52px">
        <a-button type="primary" @click="add"> +新增 </a-button>
      </div> -->
      <span style="color:#aaa;padding:0 20px">仅支持查看当前工厂下的预估记录</span>
      <!-- 表格部分 -->
      <a-table
        ref="listRef"
        :columns="columns"
        :data-source="list"
        class="tableBox"
        :pagination="pagination"
        :scroll="{ y:420, x: 1000 }"
        row-key="id"
      >
        <template slot="x" slot-scope="text, record">
          <a-space>
            <!-- <a style="marginright: 10px" @click="copy(record)">复制</a> -->
            <a style="marginright: 10px" @click="showModal(record)">详情</a>
          </a-space>
        </template>
      </a-table>

      <!-- 模态框 -->
      <DetailsModal ref="DetailsModal"></DetailsModal>
    </div>
  </a-layout>
</template>
<script>
import { columns } from "./EstimateConfig/estimateConfig";
import moment from "moment";
import logo from "@/assets/images/logo.svg"; //logo图
import DetailsModal from "./EstimateComponents/DetailsModal.vue"
import { getRequest } from "@/components/Common/Utils/Utils";
export default {
  components:{DetailsModal},
  data() {
    return {
      logo,
      factoryName: window.localStorage.getItem("factoryName"), //工厂名称
      typeList: [],
      y: 100,
      columns,
      name: "预估记录",
      form: this.$form.createForm(this),
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => {
          let { current, total: totalSize, pageSize } = this.pagination;
          let tatalPage = Math.ceil(totalSize / pageSize);
          return `共${total}条记录 ${current} / ${tatalPage}`;
        },
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.getList({ current, pageSize });
        }, //选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize;
          this.pagination.current = 1;
          this.getList({ current: 1, pageSize });
        }, //每页多少条
      },
      list: [],
      selectList: [],
      animalType: [], //保存动物类型
    };
  },
  created() {
    this.getList();
    this.getTypeList();
  },
  mounted() {
    this.y = this.$refs.listRef.$el.offsetHeight - 116;
    // this.getAnimalId();
  },
  methods: {
    showModal(record){
      this.$refs.DetailsModal.init(record);
    },
    getList(pagination) {
      let { current = 1, pageSize = 20 } = pagination || this.pagination;
      let factoryId = window.localStorage.getItem("factoryId");
      let createUser = window.localStorage.getItem("staffId");
      //表单校验
      this.form.validateFields((err, data) => {
        let { estimateDate = [], typeArr = [],reporterNo, ...newdata } = data;
        let params = {
          ...newdata,
          current,
          applyTo:'NHF',
          size: pageSize,
          factoryId,
          createUser,
          reporterNo: reporterNo ? reporterNo : undefined,
          animalTypeId:
            typeArr && typeArr.length > 0
              ? typeArr[typeArr.length - 1]
              : undefined,
          startDate: estimateDate.length
            ? moment(estimateDate[0]).format("YYYY-MM-DD 00:00:00")
            : undefined,
          endDate: estimateDate.length
            ? moment(estimateDate[1]).format("YYYY-MM-DD 23:59:59")
            : undefined,
        };
        this.$http
          .get("/sat-maximization/prediction/pageWithFormula", { params })
          .then((res) => {
            let { success, data } = res;
            if (success) {
              let { records, current = 1, total = 0 } = data;
              this.pagination.current = current;
              this.pagination.total = total;
              this.list = records || [];
            } else {
              this.$message.error("查询失败");
            }
          });
      });
    },
    resetFields() {
      this.form.resetFields();
    },
    copy(record) {
      this.$router.push(
        `/sat/estimated-record/copy?name=复制预估&id=${record.id}`
      );
    },
    details(record) {
      this.$router.push(
        `/sat/estimated-record/details?name=预估记录详情&id=${record.id}`
      );
    },
    add() {
      this.$router.push(`/sat/estimated-record/add?name=新建预估`);
    },

    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        // this.$emit('getTypeList',{targetOption,id:targetOption.id})
        this.getTypeList(targetOption.id, targetOption);
        // this.typeList = [...this.typeList];
      }, 0);
    },
    getTypeList(parentId = "0", record) {
      this.$http
        .get(`/nhf-core-data/animal/listByParentId?parentId=${parentId}`)
        .then((res) => {
          let { success, data = [] } = res;
          if (success) {
            data &&
              data.map((el) => {
                el.value = el.id;
                el.label = el.name;
                el.isLeaf = !el.hasChildren;
                return el;
              });
            if (record) {
              if (data.length) {
                record.children = data;
              } else {
                record.isLeaf = true;
              }
              this.typeList = [...this.typeList];
            } else {
              this.typeList = data;
            }
          } else {
            this.typeList = [];
          }
        });
    },
    //返回上一级
    goBack() {
      this.$router.push("/nhf-compound-editor?id="+getRequest("id"))
    },
  },
};
</script>
<style lang="scss" >
.tableBox {
  height: calc(100% - 132px);
}
</style>
<style lang="scss" scoped>
.listContent {
  background-color: #fff;
}
.nhf-logo {
  width: 80px;
  margin-right: 8px;
}
.setEstimated {
  padding: 6px 20px;
  min-height: 100vh;
  font-size: 12px;


  .nhf-header {
    padding: 10px 0 0;
  }
  .headForm{
    margin: 0;
    padding:16px 20px;
  }
  .tableBox{
     padding:10px 20px;
  }
}
.nhf-title span {
  color: #1890ff;
  padding: 0 4px;
  border-left: 4px solid #1890ff;
  line-height: 12px;
  font-size: 14px;
  font-weight: bold;
}
</style>